export enum CardType {
  COLUMN = 'column',
  IMAGE_XL = 'xl',
  IMAGE_LG = 'large',
  IMAGE_Med = 'medium',
}
